/* globals window */
import {applyMiddleware, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import {persistReducer, persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {routerMiddleware} from 'connected-react-router';
import {createBrowserHistory} from 'history';
import dynamicMiddlewares from 'redux-dynamic-middlewares';
import {RootReducer} from './reducers';
import ConfigStorage from '../configs';
import config from '../../config/env/all';

const isBrowser = typeof window !== 'undefined';
const isProdNodeEnv = config.appMode === 'production';
const composeEnhancers = (isBrowser && !isProdNodeEnv && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const history = isBrowser ? createBrowserHistory({
  basename: ConfigStorage().ROUTES.ROOT.route,
}) : null;

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['rPages', 'rServerData', 'rSocket', 'rCart'],
};

const persistedReducer = persistReducer(persistConfig, RootReducer(history));

export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(
    thunk,
    routerMiddleware(history),
    dynamicMiddlewares,
  )),
);

export const persistor = persistStore(store);
